export default "__VITE_ASSET__8SAn9Foh__"